export default "__VITE_ASSET__DhMc3XHY__"